import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Riddle from './Riddle';
import Post from './Post';
import ThreeDModel from './3dModel'; // Import the new 3DModel component
import Announcement from './Announcement'; // Import the new Announcement component
import AIAgent from './AIAgent'; // Import the new AIAgent component

const Studio = () => {
  const [activeSection, setActiveSection] = useState('post');

  return (
    <div className="container mt-4">
      <h1
        className="text-center text-white my-4 p-3 bg-secondary shadow-lg rounded"
        style={{
          backgroundColor: "#E8EFFC",
          fontFamily: "'Raleway Dots', serif",
          fontWeight: "bold",
          letterSpacing: "1.5px",
          color: "#1D223D",
        }}
      >
        Studio Central: Where Every Day Begins with a Riddle!
      </h1>

      {/* Bootstrap Navigation Tabs */}
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button
            className={`nav-link ${activeSection === 'riddle' ? 'active' : ''}`}
            onClick={() => setActiveSection('riddle')}
          >
            Riddle
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeSection === 'post' ? 'active' : ''}`}
            onClick={() => setActiveSection('post')}
          >
            Post
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeSection === 'model' ? 'active' : ''}`}
            onClick={() => setActiveSection('model')}
          >
            3D Printing Model
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeSection === 'announcement' ? 'active' : ''}`}
            onClick={() => setActiveSection('announcement')}
          >
            Announcement
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeSection === 'ai-agent' ? 'active' : ''}`}
            onClick={() => setActiveSection('ai-agent')}
          >
            AI Agent
          </button>
        </li>
      </ul>

      {/* Conditional Rendering for Sections */}
      <div className="mt-4">
        {activeSection === 'riddle' && <Riddle />}
        {activeSection === 'post' && <Post />}
        {activeSection === 'model' && <ThreeDModel />}
        {activeSection === 'announcement' && <Announcement />}
        {activeSection === 'ai-agent' && <AIAgent />}
      </div>
    </div>
  );
}

export default Studio;